var ConnectionData = /** @class */ (function () {
    function ConnectionData(data) {
        this.apiToken = (data === null || data === void 0 ? void 0 : data.apiToken) || null;
        this.dateOptionKey = (data === null || data === void 0 ? void 0 : data.dateOptionKey) || null;
    }
    ConnectionData.prototype.toJson = function () {
        return JSON.stringify(this);
    };
    ConnectionData.fromJson = function (data) {
        if (data === undefined || data === '') {
            return new ConnectionData();
        }
        return new ConnectionData(JSON.parse(data));
    };
    return ConnectionData;
}());
export default ConnectionData;
